import {Skeleton} from "@mui/material";

const ProgressWidgetSkeleton = () => (
	<Skeleton
		variant="rounded"
		sx={{
			flex: {xs: "1 1 30%", lg: "1 1 45%"},
			height: "138px",
			borderRadius: "8px"
		}}
	/>
)

export default ProgressWidgetSkeleton;